import type { CooperativeLossReason } from '../../interaction/camera';
import type { AssetId } from '../../shared/types/ids';
import { PLATFORM_ASSET_ROLES } from './stage-art-roles';

/**
 * The role *table* is next door (`stage-art-roles.ts`) and this file holds the one decision made
 * with it. Split for a boring, load-bearing reason: the table is plain data that a repository-wide
 * architecture test can read without dragging the camera stack — and therefore the DOM — into a
 * Node-only TypeScript project. Anything that has to know what a tracking loss *is* lives here.
 */
export { PLATFORM_ASSET_ROLES } from './stage-art-roles';

/**
 * Which picture goes with a loss (`CooperativeLossReason`).
 *
 * A total translation, so a reason that is added later has to be given a picture here rather than
 * silently drawing the wrong one. `UNSURE_WHO` gets the *unclear* picture rather than anything
 * about identity: the honest thing to show a room is "the camera is having trouble seeing", and
 * the alternative — art about telling two children apart — is a picture of the children being
 * compared.
 */
export function stageRecoveryArtFor(reason: CooperativeLossReason | null): AssetId | null {
  switch (reason) {
    case 'ABSENT':
      return PLATFORM_ASSET_ROLES.trackingLeftFrame;
    case 'NEVER_ACQUIRED':
      return PLATFORM_ASSET_ROLES.trackingReturn;
    case 'NO_FRAMES':
    case 'UNSURE_WHO':
      return PLATFORM_ASSET_ROLES.trackingUnclear;
    case null:
      return null;
    default:
      return PLATFORM_ASSET_ROLES.trackingReturn;
  }
}
